import Head from 'next/head';

export default function FAQ() {
    const categories = [
        {
            title: "About the Program",
            questions: [
                { q: "What is the core philosophy of L.I.S.T?", a: "L.I.S.T stands for Learning, Inspiring, Strategizing, and Transforming. It is a 4-pillar framework designed to build influential leaders specifically for luxury and high-touch industries." },
                { q: "Is this program only for Luxury Retail?", a: "While our context is specialized for luxury retail and hospitality, the leadership principles are universal and have been successfully applied in banking, real estate, and corporate hubs." }
            ]
        },
        {
            title: "Registration & Logistics",
            questions: [
                { q: "Where are the on-site workshops held?", a: "Currently, our on-site 3-Day Immersive sessions are held in premium venues in Mumbai. We provide all workshop materials, toolkits, and lunch." },
                { q: "Can I switch between online and on-site formats?", a: "Format switches are allowed up to 14 days before the program start date, subject to seat availability." }
            ]
        }
    ];

    return (
        <>
            <Head>
                <title>FAQ | L.I.S.T Learning Pathways</title>
                <meta name="description" content="Frequently asked questions about L.I.S.T leadership development programs." />
            </Head>

            <main className="min-h-screen bg-white">
                {/* Header */}
                <section className="relative overflow-hidden bg-brand-dark pt-32 pb-24 lg:pt-48 lg:pb-32">
                    <div className="absolute top-0 right-0 -translate-y-1/2 translate-x-1/4 w-[600px] h-[600px] bg-brand-primary/10 rounded-full blur-3xl"></div>
                    <div className="max-w-7xl mx-auto px-6 lg:px-12 relative z-10">
                        <span className="inline-block px-5 py-2 bg-brand-primary/20 text-white text-sm font-bold rounded-full mb-6">
                            Support Hub
                        </span>
                        <h1 className="text-5xl md:text-7xl font-extrabold text-white mb-8 leading-[1.1] tracking-tight">
                            Questions & <span className="text-brand-primary italic">Answers</span>
                        </h1>
                        <p className="text-xl text-gray-300 max-w-2xl leading-relaxed">
                            Everything you need to know about starting your leadership journey with us.
                        </p>
                    </div>
                </section>

                {/* FAQ Content */}
                <section className="py-24 bg-white">
                    <div className="max-w-7xl mx-auto px-6 lg:px-12">
                        <div className="max-w-4xl mx-auto">
                            {categories.map((cat, i) => (
                                <div key={i} className="mb-24 last:mb-0">
                                    <div className="flex items-center gap-4 mb-12">
                                        <div className="w-12 h-1.5 bg-brand-primary rounded-full"></div>
                                        <h2 className="text-sm font-black text-brand-primary">{cat.title}</h2>
                                    </div>
                                    <div className="space-y-14">
                                        {cat.questions.map((item, qIdx) => (
                                            <div key={qIdx} className="group cursor-default">
                                                <h4 className="text-2xl font-bold text-brand-dark mb-6 leading-tight group-hover:text-brand-primary transition-colors flex gap-6">
                                                    <span className="text-brand-primary/20 group-hover:text-brand-primary/40 select-none font-black tracking-tighter">Q.</span>
                                                    {item.q}
                                                </h4>
                                                <div className="flex gap-6">
                                                    <span className="text-transparent select-none font-black tracking-tighter w-8 invisible">Q.</span>
                                                    <p className="text-gray-500 text-lg leading-relaxed max-w-3xl border-l border-gray-100 pl-8 group-hover:border-brand-primary/30 transition-colors">
                                                        {item.a}
                                                    </p>
                                                </div>
                                            </div>
                                        ))}
                                    </div>
                                </div>
                            ))}
                        </div>
                    </div>
                </section>

                {/* Contact CTA */}
                <section className="pb-24 bg-white">
                    <div className="max-w-7xl mx-auto px-6 lg:px-12">
                        <div className="bg-gray-50/50 p-12 lg:p-20 rounded-[3.5rem] text-center border border-gray-100 shadow-2xl shadow-gray-200/50 relative overflow-hidden">
                            <div className="absolute top-0 left-0 w-32 h-32 bg-brand-primary/5 rounded-full blur-3xl"></div>
                            <h3 className="text-3xl md:text-5xl font-extrabold text-brand-dark mb-6 tracking-tight">Still have <span className="text-brand-primary">questions</span>?</h3>
                            <p className="text-lg text-gray-500 mb-10 max-w-2xl mx-auto">We are here to help you make the right choice for your career. Our team is ready to assist you.</p>
                            <a href="/contact" className="inline-block px-12 py-5 bg-brand-primary text-white font-bold rounded-lg shadow-xl shadow-brand-primary/20 hover:shadow-brand-primary/40 transition-all active:scale-95 text-sm">
                                Contact Support
                            </a>
                        </div>
                    </div>
                </section>
            </main>
        </>
    );
}
